import { PixButton, PixModal, PixSelect } from '@1024pix/nebulix-ember';
import { hash } from '@ember/helper';
import t from 'ember-intl/helpers/t';

<template>
  <PixModal
    class='select-referer-modal'
    @title={{t 'pages.team.select-referer-modal.title'}}
    @onCloseButtonClick={{@toggleRefererModal}}
    @showModal={{@showModal}}
  >
    <:content>
      <div class='select-referer-modal__referer-selector'>
        <PixSelect
          @id='referer'
          @options={{@options}}
          @value={{@selectedReferer}}
          @texts={{hash placeholder=(t 'pages.team.select-referer-modal.empty-option')}}
          @hideDefaultOption={{true}}
          @onChange={{@onSelectReferer}}
          @emptyOptionNotSelectable={{true}}
        >
          <:label>{{t 'pages.team.select-referer-modal.label'}}</:label>
        </PixSelect>
      </div>
      <div class='select-referer-modal__actions'>
        <PixButton
          aria-label='{{t "pages.team.select-referer-modal.actions.cancel-extra-information"}}'
          @variant='secondary'
          @isBorderVisible={{true}}
          @triggerAction={{@toggleRefererModal}}
        >
          {{t 'common.actions.cancel'}}
        </PixButton>
        <PixButton
          class='select-referer-modal__validation-button'
          aria-label='{{t "pages.team.select-referer-modal.actions.validate-extra-information"}}'
          @triggerAction={{@onValidateReferer}}
          @loadingColor='white'
          @isDisabled={{@noSelectedReferer}}
          @variant='primary'
        >
          {{t 'pages.team.select-referer-modal.actions.validate'}}
        </PixButton>
      </div>
    </:content>
    <:footer>
      <p class='select-referer-modal__description'>
        {{t 'pages.team.select-referer-modal.description' htmlSafe=true}}
      </p>
    </:footer>
  </PixModal>
</template>
